import http from '../../../lib/http'

export const PRACTITIONERS = 'PRACTITIONERS'
export const PRACTITIONERS_SUCCESS = 'PRACTITIONERS_SUCCESS'
export const PRACTITIONERS_FAILURE = 'PRACTITIONERS_FAILURE'
export const FETCH_INSTANCES_SUCCESS = 'FETCH_INSTANCES_SUCCESS'

export function getPractitioners () {
  return (dispatch, getState) => {
    const { auth: user } = getState()
    dispatch({ type: PRACTITIONERS })
    return http
      .getRequest('/practitioners')
      .then(data =>
        dispatch({
          type: PRACTITIONERS_SUCCESS,
          results: data,
          current_user: user
        }))
      .catch(err =>
        dispatch({
          type: PRACTITIONERS_FAILURE,
          err
        }))
  }
}
